import { type MetricField, UserDimension } from "../../gql-generated/types";

export const generateFieldsList = (
    fields: MetricField[],
): { fieldName: MetricField; reportDimension: UserDimension }[] =>
    fields.map((fieldName) => ({ fieldName, reportDimension: UserDimension.UserDimensionUnset }));
